import React,{useState, forwardRef} from 'react'
import { CheckOutlined, CopyOutlined} from '@ant-design/icons';
import { Alert, Button,Typography ,Form} from 'antd';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import BaseModal from 'components/BaseModal';
import { generateFormFields } from 'utils/formUtils';

export default forwardRef(function WebhookModel({id,toolName, afterClose}, ref) {

    const [webhookToken, setWebhookToken] = useState("");
    const [form] = Form.useForm();
    const [loading,setLoading] = useState(false);

    const tokenGenerateSection = (
        <>
        <div className="text-bold">URL</div>
        <Typography.Text copyable={{ 
            text: webhookToken,
            icon: [<Button key="copy-icon" icon={<CopyOutlined />} type="link">Copy</Button>, <Button key="copied-icon" icon={<CheckOutlined />} type="link">Copied</Button>], 
        }}>{webhookToken}</Typography.Text>
        </>
    )
    
    const generateWebhookToken = async (values, id) => {
        setLoading(true);
        values.id = id;
        const {url} = await ToolsIntegrationsAPI.getSecuritytoolWebhookToken(values, toolName).promise;
        setWebhookToken(url);
        setLoading(false);
    }


    return(
        <BaseModal modalProps={{title: "Webhook", footer: null}} ref={ref} afterClose={afterClose}>
            <Form
                form={form}
                layout="vertical"
                onFinish={(values) => generateWebhookToken(values, id)}
            >
             {generateFormFields([{
                name: "secret",
                label: "Secret",
                rules: [{
                    required: true,
                    message: "secret key is required"
                }]
             }])}
            <Button type="primary" loading={loading} htmlType="submit">Generate URL</Button>
            </Form>
            {webhookToken && <Alert className="m-t-l" description={tokenGenerateSection} type="info"/>}
        </BaseModal>
    )
})
